import React from "react";
import PropTypes from "prop-types";
import { SEO, Modal2 } from "@qgiv/core-donor";
import AccountModalContent from "./AccountModalContent";
import FauxProfile from "./FauxProfile";

const AccountPage = ({ eventHome, documentTitle }) => {
    // Redirect the user to the event home page
    const handleCloseAccountModal = () => {
        window.location.href = eventHome;
    };

    return (
        <>
            <SEO title={documentTitle} description="" />
            <Modal2
                onClose={handleCloseAccountModal}
                closeOnClickOutside={false}
                scrollOverflow
            >
                <AccountModalContent />
            </Modal2>
            <FauxProfile />
        </>
    );
};

AccountPage.propTypes = {
    eventHome: PropTypes.string.isRequired,
    documentTitle: PropTypes.string.isRequired,
};

export default AccountPage;
